{
  "filter": {
    "ariaLabel": "Search and filter questions",
    "searchLabel": "Search questions",
    "searchPlaceholder": "Search questions...",
    "categoryAria": "Filter by category",
    "all": "All"
  },
  "categories": {
    "ariaLabel": "Browse by category"
  },
  "list": {
    "banner": {
      "prefix": "You're seeing today's",
      "count": "{count} free questions",
      "suffix": "— a daily rotating selection from our classic discovery set.",
      "note": "The selection refreshes tomorrow with new picks. Subscribe to instantly unlock all questions, anytime.",
      "cta": "See plans"
    },
    "loadMore": "Load More"
  },
  "card": {
    "flipAria": "{action}: {question}",
    "flip": {
      "showImage": "Show question image",
      "showAnswer": "Flip to see answer"
    },
    "readMore": "Read More",
    "readMoreAria": "Read more about: {question}",
    "save": "Save",
    "saved": "Saved"
  },
  "editorsPick": {
    "title": "This Week's Picks",
    "lockedTitle": "Unlock all questions",
    "subscribe": "Subscribe"
  },
  "preview": {
    "seeAll": "See all {category}"
  }
}
